import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
  selector: '[fExtendedFileSelectTemplate]',
  standalone: false
})
export class FireflyExtendedFileSelectTemplateDirective {
  template = inject(TemplateRef<unknown>);
}
